// extracted by mini-css-extract-plugin
export default {"content":"UaeDyYnz","subtitle":"uo__VjNB","editorial":"ba5YXlMg"};